import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, DialogActions, DialogContent, IconButton, } from '@mui/material';
import closeButton from '../../Assets/popup-close.svg';
import Preview from './Slide_Preview';

const CalloutNamePopup = ({ open, onSave, onClose, eventName, handleInputChange }) => {
  const handleClose = () => onClose();

  const inputRef = useRef(null);
  const [maxChars, setMaxChars] = useState(50);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setErrorMsg('');
  }, [open]);

  useEffect(() => {
    if (inputRef.current)
      setMaxChars(50 - inputRef.current.value.length);
  }, [handleInputChange]);


  const handleSave = () => {
    onSave();
    handleClose();
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Adjust the opacity here
        },
      }}
      maxWidth="xs"
      fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
          }}
        >
          <p style={{ fontSize: "20px", fontWeight: "600", }}>Callout Name is optional. Enter a name if you wish, or continue without one.</p>
          <IconButton onClick={handleClose}>
            <img src={closeButton} alt="close-button" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'center', gap: '10px', paddingLeft: '15px' }}>
          <p style={{ fontSize: '17px', color: '#757ea5', fontWeight: "500" }}>Callout Name (<span style={{ fontSize: '15px', fontWeight: 'bold', color: maxChars === 50 ? '#289e13' : '#ff0000' }}>{maxChars}</span> <span style={{ fontSize: '15px' }}>chars</span>)</p>
          <p style={{ color: '#ff0000' }}>{errorMsg}</p>
          <input type='text' onChange={handleInputChange} maxLength={50} ref={inputRef} style={{ width: '85%', height: "40px", fontSize: "16pxf", border: "1px solid #CFD4E9" }} />
          <div style={{}}></div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '10px' }}>
          <Button variant='contained' style={{ backgroundColor: '#02ACF6', textTransform: 'none', height: "35px" }} onClick={() => { handleSave() }} className="dialog-save-button">
            Save
          </Button>
        </div>

      </DialogContent>
    </Dialog>
  )

}

export default CalloutNamePopup;